import React, { useState } from 'react'
import ConfirmModal from './Actions/ConfirmModal';
interface props{
  userId:string
}
function QuizDetails({userId}:props) {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const handleStart = async () => {
    setIsModalOpen(true);
   
  }
  return (
    <div> {
        isModalOpen && <> <ConfirmModal isOpen={isModalOpen} closeModal={closeModal} gUserId={userId}/>
       </>
       }
    
        <div className='d-flex justify-content-center align-items-center'  style={{ flexDirection: "column" }}>
                <h2 className='mb-3 mt-3'>Please click the start button</h2>
                <button onClick={() => handleStart()} className='btn btn-primary'>Start</button>
      </div></div>
  )
}

export default QuizDetails